import React from 'react';
import { FormattedMessage } from 'react-intl';
import { User } from '../../../../common/core-api';
import UserItem from './UserItem';
import * as Styled from './UserList.styled';
import { NoUserMessage } from './FollowingContent.styled';

export const UserList = React.forwardRef(function UserList(
  {
    userList,
    onProfilePopupLoaded,
    type,
    toggleFollowState,
    refetchUsers,
    isProfileOwner,
    userFollowing,
    setUserFollowing,
    hideShowMoreButton,
    updateIndex
  }: {
    userList: User[];
    onProfilePopupLoaded: (id: string) => void;
    type: 'followersTab' | 'followingTab';
    toggleFollowState: (id: string, type: string) => void;
    refetchUsers: () => void;
    isProfileOwner: boolean;
    userFollowing: number;
    setUserFollowing: (count: number) => void;
    userFollowers: number;
    setUserFollowers: (count: number) => void;
    hideShowMoreButton: boolean;
    updateIndex: () => void;
  },
  ref: React.Ref<HTMLDivElement>
) {
  const userPagination = 100;

  const getMoreUsers = () => {
    const count = userFollowing + userPagination;
    setUserFollowing(count);
  };

  if (!userList) {
    return null;
  }

  return (
    <div ref={ref}>
      <Styled.UserListContainer>
        {userList.map((user) => (
          <UserItem
            key={user.id}
            user={user}
            onProfilePopupLoaded={onProfilePopupLoaded}
            type={type}
            toggleFollowState={toggleFollowState}
            refetchUsers={refetchUsers}
            isProfileOwner={isProfileOwner}
            updateIndex={updateIndex}
          />
        ))}
      </Styled.UserListContainer>
      {hideShowMoreButton ? (
        <NoUserMessage>
          <FormattedMessage id="noUsersFound" defaultMessage="No users found." />
        </NoUserMessage>
      ) : (
        <Styled.MoreButton priority="secondary" onClick={getMoreUsers}>
          <FormattedMessage id="showMore" defaultMessage="Show more" />
        </Styled.MoreButton>
      )}
    </div>
  );
});

export default UserList;
